import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { DateValue } from '@web/utils';
import { DD_MM_YYYY_HH_MM_SS } from '@web/common';

@Component({
  selector: 'app-date-time',
  imports: [CommonModule, DateFormatPipe],
  templateUrl: './date-time.component.html',
  styleUrls: ['./date-time.component.scss'],
})
export class DateTimeComponent {
  @Input() public date!: DateValue;

  protected readonly DD_MM_YYYY_HH_MM_SS = DD_MM_YYYY_HH_MM_SS;
}
